import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiUrl = environment.API_URL + 'internal/';

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService
  ) { }

  getV2Header() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tokenService.getTokenV2(),
      'Accept-Language': 'pt-BR'
    });
  }

  public getBranchList(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrl + 'management/v2/branches/', { headers: this.getV2Header() });
  }

  public getMenuList(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrl + 'management/v2/menu?branchcode=' + this.tokenService.getBranch(), { headers: this.getV2Header() });
  }

  public postCustomerToken(componentCode: string): Observable<any> {
    let data = {
      'componentCode': componentCode,
    }
    return this.httpClient.post<any>(this.apiUrl + 'authorization/v2/customer-component-token', data, { headers: this.getV2Header() });
  }

  public getProduct(BarCode: number, BranchCode: number): Observable<any> {
    return this.httpClient.get<any>(this.apiUrl + 'product/v2/products/' + BarCode + '/' + BranchCode, { headers: this.getV2Header() });
  }
}
